module.exports = __webpack_public_path__ + "static/media/mole_poster.414be6eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/mole_poster.jpg
// module id = 221
// module chunks = 0